<template>
  <div class="feature-container">
    <div class="feature-item" v-for="(feature, i) in featureList" :key="feature.id">
      <div class="feature-title">
        <span class="name">{{feature.moduleName}}</span>
        <el-checkbox v-model="feature.checked" @change="featureAll(feature, i)" :disabled="featureType == 1 || feature.disabled">全选</el-checkbox>
      </div>
      <div class="feature-content">
        <div v-for="(item, index) in feature.funcList" :key="index">
          <el-checkbox v-model="item.checked" @change="featureChange(feature, i, item)" :disabled="featureType == 1 || item.disabled">{{item.name}}</el-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['featureData'],
  data () {
    return {
      checked: false,
      featureList: [],
      featureType: 1, // 1: 详情（禁用状态） 2：编辑  3:编辑（选中部分禁用 - 增购）
      responseData: this.featureData
    }
  },
  watch: {
    featureData (data) {
      this.featureInit(this.featureData)
    }
  },
  mounted () {
    this.featureInit(this.featureData)
  },
  methods: {
    /** 功能清单 - 数据初始化 */
    featureInit (data) {
      console.log(data, typeof data)
      if (!data.data) {
        return
      }
      data = JSON.parse(JSON.stringify(data))
      this.featureType = data.type
      this.featureList = data.data
      this.featureList.map((v, i) => {
        var to = 0
        var dis = 0
        let okr1
        let okr2
        v.funcList.map((v2, i2) => {
          if (v2.choice === '1') {
            if (data.type === 3) {
              v2.disabled = true
            }
            v2.checked = true
            to++
          }
          if (v2.disabled) dis++
          if (v2.id === 40) {
            okr1 = i2
          }
          if (v2.id === 48) {
            okr2 = i2
          }
        })
        if (okr1 >= 0 && okr2 >= 0) {
          let obj = v.funcList.splice(okr1, 1)
          v.funcList.splice(okr2 - 1, 0, obj[0])
          v.funcList[okr2].disabled = !v.funcList[okr1].checked || (v.funcList[okr2].choice === '1' && (v.funcList[okr2].from_type === '0' || v.funcList[okr2].from_type === '2'))
          if (!v.funcList[okr1].checked) {
            v.funcList[okr2].checked = false
          }
        }
        if (to === v.funcList.length && to !== 0) {
          v.checked = true
        }
        if (dis === v.funcList.length && dis !== 0) {
          v.disabled = true
        }
        if (to > 0 && data.type === 3) {
          v.disabled = true
        }
      })
      console.log(this.featureList)
      this.$bus.emit('feature-edit', this.featureList)
    },
    /** 功能清单 - 全选 */
    featureAll (tag, tag2) {
      tag.funcList.map((item) => {
        if (!item.disabled) item.checked = tag.checked
      })
      console.log(this.featureList)
      this.$set(this.featureList, tag2, tag)
      this.$bus.emit('feature-edit', this.featureList)
    },
    /** 功能清单 - 单选 */
    featureChange (tag, tag2, tag3) {
      console.log(tag, tag2, tag3)
      if (tag3.id === 4 || tag3.id === 40) {
        let task = tag.funcList.some(v => {
          return v.checked && (v.id === 4 || v.id === 40)
        })
        let i1 = tag.funcList.findIndex(v => {
          return v.id === 41
        })
        if (i1 >= 0) {
          if (task) {
            tag.funcList[i1].checked = task
          }
          tag.funcList[i1].disabled = task
        }
        let okr = tag.funcList.find(v => {
          return v.id === 40
        })
        if (okr) {
          let i2 = tag.funcList.findIndex(v => {
            return v.id === 48
          })
          if (i2 >= 0) {
            tag.funcList[i2].disabled = !okr.checked
            if (!okr.checked) {
              tag.funcList[i2].checked = false
            }
          }
        }
      }
      var num = 0
      tag.funcList.map((item) => {
        if (item.checked) num++
      })
      tag.checked = (num !== 0 && tag.funcList.length === num)
      this.$set(this.featureList, tag2, tag)
      this.$bus.emit('feature-edit', this.featureList)
    }
  }
}
</script>

<style lang="scss">
.feature-container{
  height: 100%;
  overflow-y: auto;
  .feature-title{
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    border-bottom: 1px dashed #d9d9d9;
    .name{
      font-size: 14px;
      color: #1890FF;
      letter-spacing: 0.22px;
      display: inline-block;
      width: 97px;
    }
  }
  .feature-content{
    padding: 20px 0 0 20px;
    line-height: 1;
  }
  .feature-content > div{
    margin: 0 10px 20px 0;
    min-width: 130px;
    display: inline-block;
    line-height: 1;
  }
  .el-checkbox + .el-checkbox{
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/feature-list.vue